import React from "react";
import { Flex, Box } from "grid-styled";
import { Field } from "redux-form";
import InputContainer from "./InputContainer";
import AddressFields from "./AddressFields";

const join = (...pathPieces) => pathPieces.filter(piece => !!piece).join(".");

const ContactFields = ({ path }) => {
  return (
    <Box>
      <Flex pb={2}>
        <Box width={1 / 2} pr={1}>
          <Field
            name={join(path, "firstName")}
            labelText="First Name"
            placeholder="e.g., Nathan"
            component={InputContainer}
          />
        </Box>
        <Box width={1 / 2} pl={1}>
          <Field
            name={join(path, "lastName")}
            labelText="Last Name"
            placeholder="e.g., Drake"
            component={InputContainer}
          />
        </Box>
      </Flex>
      <Flex pb={2}>
        <Box width={1 / 2} pr={1}>
          <Field
            name={join(path, "otherFirstName")}
            labelText="Other First Name"
            placeholder="e.g., Elena"
            component={InputContainer}
          />
        </Box>
        <Box width={1 / 2} pl={1}>
          <Field
            name={join(path, "otherLastName")}
            labelText="Other Last Name"
            placeholder="e.g., Fisher"
            component={InputContainer}
          />
        </Box>
      </Flex>
      <Flex pb={2}>
        <Box width={1 / 2} pr={1}>
          <Field
            name={join(path, "email")}
            labelText="Email Address"
            placeholder="e.g., nathan@jamesoninc.com"
            component={InputContainer}
          />
        </Box>
        <Box width={1 / 2} pl={1}>
          <Field
            name={join(path, "phone")}
            labelText="Phone Number"
            placeholder="e.g., 555-555-5555"
            component={InputContainer}
          />
        </Box>
      </Flex>
      <AddressFields
        name="Mailing Address"
        path={join(path, "address")}
        shouldValidate={true}
      />
    </Box>
  );
};

export default ContactFields;



// WEBPACK FOOTER //
// ./src/components/forms/ContactFields.js